import { OverflowDisplayTooltip } from "../../OverflowDisplayTooltip";
import { FileIcon } from "../FileIcon";
import { formatSkillPathForDisplay } from "../utils";

export interface SkillCollectionContentHeaderProps {
  filePath: string | null;
  displayLabel?: string;
  trailingContent?: JSX.Element | null;
  placeholder?: string;
}

export const SkillCollectionContentHeader = ({
  filePath,
  displayLabel,
  trailingContent,
  placeholder = "Select a file",
}: SkillCollectionContentHeaderProps) => {
  const resolvedDisplayLabel = filePath
    ? (displayLabel ?? formatSkillPathForDisplay(filePath))
    : placeholder;
  const tooltipContent = filePath ?? placeholder;

  return (
    <div className="flex h-[37px] items-center gap-3 border-b border-gray-200 bg-gray-50/70 px-3">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        {filePath ? <FileIcon path={filePath} /> : null}
        <OverflowDisplayTooltip
          content={tooltipContent}
          side="bottom"
          className="min-w-0 flex-1"
        >
          <span className="block truncate text-sm font-medium text-gray-700">
            {resolvedDisplayLabel}
          </span>
        </OverflowDisplayTooltip>
      </div>
      {trailingContent}
    </div>
  );
};
